import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Router } from "@angular/router";
import { DialogFactory } from "@bitwarden/web-vault/app/components/dialog/dialogFactory";

@Component({
  selector: "app-help-guide",
  templateUrl: "./help-guide.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpGuideComponent {
  private dialogFactory: DialogFactory;
  constructor() {
    this.dialogFactory = new DialogFactory();
  }

  goToGuideDetail() {
    this.dialogFactory.openGuideDialog();
  }

  openHelpBox() {
    this.dialogFactory.callHelpBox(true);
  }

  openFaq() {
    try {
      window.open("https://www.gloss-vault.com/faq", "_blank", "noopener,noreferrer");
    } catch (e) {
      window.location.href = "https://www.gloss-vault.com/faq";
    }
  }
}
